<style lang="less" scoped>
  .v-dialog__content {
    /deep/ .v-dialog--scrollable {
      display: inline-block;
    }
    /deep/ .v-dialog {
      position: relative;
      min-height: 350px;
    }
  }
  .content {
    position: absolute;
    top: 50px;
    bottom: 60px;
    padding: 20px;
    overflow: auto;
  }
</style>
<template>
  <v-dialog
    ref="modal"
    v-model="value"
    v-bind="$attrs"
    persistent
    class="dialog"
    :fullscreen="fullscreen"
    :hide-overlay="fullscreen"
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-toolbar
      :absolute="fullscreen"
      height="50"
      min-width="100%"
      flat
      color="#f5f5f5"
    >
      <v-toolbar-title>
        <slot name="header">
          {{ title }}
        </slot>
      </v-toolbar-title>
      <v-spacer />
     
      <v-toolbar-items
        v-show="showHeaderClose"
        style="margin-right: -16px"
      >
        <v-btn
          icon
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar-items>
      <div
        class="v-toolbar__items"
      >
        <slot
          v-bind="{close}"
          name="headerLast"
        /> 
      </div>
    </v-toolbar>
    <div
      class="content"
    >
      <slot />
    </div>

    <v-footer
      v-show="!notShowFooter"
      height="60"
      absolute
    >
      <slot name="footer">
        <v-spacer />
        <v-btn
          v-if="cancelText"
          text
          @click="close"
        >
          {{ cancelText }}
        </v-btn>
        <space />
        <v-btn
          :color="successColor"
          :loading="loading"
          :text="okTextDis"
          @click="ok"
        >
          {{ okText }}
        </v-btn>
      </slot>
    </v-footer>

    <VOverlayLoading :value="contentLoading" />
  </v-dialog>
</template>

<script>
  import VOverlayLoading from './v-overlay-loading';
  import { mapState } from "vuex";

  export default {
    name: "Modal",
    components: { VOverlayLoading },
    inheritAttrs: false,
    props: {
      notShowFooter: {
        type: Boolean,
        default: false
      },
      heightRate: {
        type: Number,
        default: 0.85,
      },
      dynamicHeight: {
        type: Boolean,
        default: false
      },
      value: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      contentLoading: {
        type: Boolean,
        default: false
      },
      okText: {
        type: String,
        default: '确定'
      },
      cancelText: {
        type: String,
        default: '取消'
      },
      showHeaderClose: {
        type: Boolean,
        default: true
      },
      showHeaderCloseI: {
        type: Boolean,
        default: false
      },
      successColor: {
        type: String,
        default: 'primary'
      },
      okTextDis: {
        type: Boolean,
        default: false
      }
    },
    // events
    // @ok, @cancel
    data() {
      return {
        inner_loading: false
      }
    },
    methods: {
      setModalHeight() {
        if (this.fullscreen) {
          return 
        }
        const current = ['$refs', 'dialog'].reduce((total, item) => total[item] || {}, this.$refs.modal)
        if (current && current.style) {
          current.style.height = this.window_height * this.heightRate + 'px'
        }
      },
      close() {
        this.$emit('input', false);
        this.$emit('cancel');
      },
      ok() {
        this.$emit('ok');
      }
    },
    computed: {
      ...mapState(['window_height']),
    },
    watch: {
      window_height() {
        if (this.$refs.modal && this.value && this.dynamicHeight) {
          this.setModalHeight()
        }
      },
      value(val) {
        if (val && this.dynamicHeight) {
          setTimeout(() => {
            this.setModalHeight()
          }, 150)
        }
      }
    },
  }
</script>
